"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Controllers = void 0;
const React = __importStar(require("react"));
const core_1 = require("./core");
const emitter_1 = require("./emitter");
const type_1 = require("../../type");
const Field_Constant_1 = require("./utils/Field.Constant");
const Field_Submit_1 = require("./utils/Field.Submit");
const CorePreview_1 = __importDefault(require("./core/CorePreview"));
const Controllers = ({ mode = "normal" || "object", fields = [], onCancel, onSubmit, loading = false, labelSubmit = "Submit", labelCancel = "Cancel", classNameCancel = "", classNameSubmit = "", classNameWrapper = "", loadData = {}, language = "TH", firstButton = "cancel", renderAlertError = false, showError = true, error = type_1.TYPE_ERROR_NORMAL, resetAfterSubmit = false, showSymbol = true, showErrorAlert = true, preview = false, renderPreview = null, classNamePreview = "", classNameSuperCore = "", validateDataNoChange = [], }) => {
    console.warn = function filterWarnings() {
        return;
    };
    console.error = function filterErrors() {
        return;
    };
    const [reset, setReset] = React.useState(false);
    const ARRAY = new Array("");
    const FieldReference = React.useRef(ARRAY);
    const FunctionReset = () => {
        setReset(true);
        setTimeout(() => {
            setReset(false);
        }, 100);
    };
    return (React.createElement(emitter_1.EventEmitterProvider, null,
        preview && (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-preview ${classNamePreview}` },
            React.createElement(CorePreview_1.default, { renderPreview: renderPreview, FieldReference: FieldReference, fields: fields }))),
        React.createElement("div", { style: preview ? { display: "none" } : {}, className: `${Field_Constant_1.TEXT_AUTHOR}-super-core ${classNameSuperCore}` },
            React.createElement(core_1.FunctionCore, { reset: reset, FunctionReset: FunctionReset, mode: mode, fields: fields, key: `${Field_Constant_1.TEXT_AUTHOR}-core-${mode}`, FieldReference: FieldReference, loadData: loadData, language: language, fieldIndex: 0, grandParentIndex: 0, grandParentKey: "", parentIndex: 0, parentKey: "", showError: showError, showSymbol: showSymbol, showErrorAlert: showErrorAlert, validateDataNoChange: validateDataNoChange })),
        React.createElement("div", { style: {
                marginTop: "10px",
            }, className: `${Field_Constant_1.TEXT_AUTHOR}-wrapper ${classNameWrapper}` }, firstButton === "cancel" ? (React.createElement(React.Fragment, null,
            onCancel && (React.createElement("button", { id: `${Field_Constant_1.TEXT_AUTHOR}-button-cancel`, className: `${Field_Constant_1.TEXT_AUTHOR}-cancel ${classNameCancel}`, onClick: (e) => {
                    if (onCancel) {
                        onCancel({ FunctionReset });
                    }
                    else {
                        return;
                    }
                } }, labelCancel)),
            onSubmit && (React.createElement("button", { id: `${Field_Constant_1.TEXT_AUTHOR}-button-submit`, className: `${Field_Constant_1.TEXT_AUTHOR}-submit ${classNameSubmit}`, onClick: () => {
                    if (loading) {
                        return;
                    }
                    else {
                        (0, Field_Submit_1.FunctionSubmit)(fields, FieldReference, onSubmit, renderAlertError, error, FunctionReset, resetAfterSubmit, showErrorAlert, loadData, validateDataNoChange);
                    }
                } }, labelSubmit)))) : (React.createElement(React.Fragment, null,
            onSubmit && (React.createElement("button", { id: `${Field_Constant_1.TEXT_AUTHOR}-button-submit`, className: `${Field_Constant_1.TEXT_AUTHOR}-submit ${classNameSubmit}`, onClick: () => {
                    if (loading) {
                        return;
                    }
                    else {
                        (0, Field_Submit_1.FunctionSubmit)(fields, FieldReference, onSubmit, renderAlertError, error, FunctionReset, resetAfterSubmit, showErrorAlert, loadData, validateDataNoChange);
                    }
                } }, labelSubmit)),
            onCancel && (React.createElement("button", { id: `${Field_Constant_1.TEXT_AUTHOR}-button-cancel`, className: `${Field_Constant_1.TEXT_AUTHOR}-cancel ${classNameCancel}`, onClick: () => {
                    if (onCancel) {
                        onCancel({ FunctionReset });
                    }
                    else {
                        return;
                    }
                } }, labelCancel)))))));
};
exports.Controllers = Controllers;
